import React from 'react';
export function ForYourBabySection() {
  return <section id="do-it-for-them" className="bg-[#faf7f4] py-[100px] px-6 font-serif overflow-hidden" data-id="element-71">
      <div className="max-w-[1100px] mx-auto flex flex-col-reverse md:flex-row items-center gap-10 md:gap-20 flex-wrap justify-center" data-id="element-72">
        {/* ── LEFT COLUMN: COPY ── */}
        <div className="flex-1 min-w-[300px] md:min-w-[380px] max-w-full md:max-w-[500px] flex flex-col gap-7 text-left" data-id="element-73">
          {/* Top badge */}
          <span className="inline-block w-fit bg-[#f0e8e0] text-[#8B5E52] text-[11px] font-sans font-bold tracking-[2.5px] uppercase py-[7px] px-[18px] rounded-full" data-id="element-74">
            ✦ A decision that changes everything
          </span>

          {/* Main title */}
          <h2 className="text-[clamp(30px,4vw,46px)] text-[#2c1810] leading-[1.25] m-0 font-bold" data-id="element-75">
            Do it for them.
            <br data-id="element-76" />
            <span className="text-[#8B5E52] italic font-normal" data-id="element-77">
              Do it for you too.
            </span>
          </h2>

          {/* Decorative divider line */}
          <div className="w-[60px] h-[3px] bg-[#c9a090] rounded-sm" data-id="element-78" />

          {/* Paragraph 1 — For the baby */}
          <p className="text-[17px] leading-[1.85] text-[#5a4a42] font-sans m-0" data-id="element-79">
            Those little feet you see right now{' '}
            <strong className="text-[#2c1810]" data-id="element-80">
              won't be little for long.
            </strong>{' '}
            The first year of life is the only window in which your baby's brain
            is built at a speed that will never be repeated again. What happens
            in these 365 days{' '}
            <strong className="text-[#2c1810]" data-id="element-81">
              matters more than anything else
            </strong>{' '}
            you will do as a parent.
          </p>

          {/* Paragraph 2 — For the parent */}
          <p className="text-[17px] leading-[1.85] text-[#5a4a42] font-sans m-0" data-id="element-82">
            But this is also true:{' '}
            <strong className="text-[#2c1810]" data-id="element-83">
              an exhausted parent cannot give their best.
            </strong>{' '}
            You need to sleep. You need clarity. You need to know you're doing
            it right. This protocol is not just for your baby —{' '}
            <strong className="text-[#2c1810]" data-id="element-84">
              it's so you can breathe again too.
            </strong>
          </p>

          {/* 3 emotional micro-points */}
          <div className="flex flex-col gap-3.5 mt-1" data-id="element-85">
            {[{
            icon: '🤍',
            text: 'So every moment counts, without guilt and without fear.'
          }, {
            icon: '🧠',
            text: 'So your baby reaches age one with a solid neurological foundation.'
          }, {
            icon: '🌙',
            text: 'So you can sleep again and actually enjoy this stage.'
          }].map((item, i) => <div key={i} className="flex items-start gap-3.5 bg-white border-[1.5px] border-[#ede5df] rounded-2xl py-3.5 px-[18px] shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-86">
                <span className="text-[20px] leading-none" data-id="element-87">{item.icon}</span>
                <p className="m-0 text-[15px] leading-[1.6] text-[#5a4a42] font-sans" data-id="element-88">
                  {item.text}
                </p>
              </div>)}
          </div>

          {/* Closing quote */}
          <blockquote className="mt-2 mb-0 py-5 px-6 bg-[#f5ede8] border-l-4 border-[#c9a090] rounded-r-2xl italic text-base text-[#7a5a50] leading-[1.7] font-serif" data-id="element-89">
            "It's not about being the perfect parent. It's about being the{' '}
            <strong className="font-bold" data-id="element-90">present and prepared</strong> parent
            your baby needs."
          </blockquote>
        </div>

        {/* ── RIGHT COLUMN: IMAGE ── */}
        <div className="flex-1 min-w-[300px] md:min-w-[380px] max-w-full md:max-w-[480px] w-full relative" data-id="element-91">
          {/* Decorative background circle */}
          <div className="hidden md:block absolute top-[-30px] right-[-30px] w-[300px] h-[300px] bg-[#f0e8e0] rounded-full z-0 opacity-60" data-id="element-92" />

          {/* Main image */}
          <img src="https://cdn.magicpatterns.com/uploads/jSB5gg1Ggmjj2hzq5gwis9/ChatGPT_Image_2_abr_2026,_01_49_20_a.m..png" alt="Baby feet next to tablet with Your Baby's First Year" className="w-full h-auto rounded-3xl shadow-[0_30px_80px_rgba(0,0,0,0.15)] relative z-10 block" data-id="element-93" />

          {/* Floating card — social proof */}
          <div className="absolute bottom-6 left-[-20px] bg-white rounded-2xl py-3.5 px-5 shadow-[0_10px_40px_rgba(0,0,0,0.12)] z-20 flex items-center gap-3 max-w-[240px]" data-id="element-94">
            <span className="text-[28px]" data-id="element-95">👶</span>
            <div data-id="element-96">
              <p className="m-0 text-[13px] font-bold text-[#2c1810] font-sans" data-id="element-97">
                +2,400 families
              </p>
              <p className="m-0 text-[12px] text-[#9a8880] font-sans" data-id="element-98">
                already live this difference
              </p>
            </div>
          </div>

          {/* Floating card — stars */}
          <div className="absolute top-6 right-[-10px] bg-white rounded-2xl py-3 px-[18px] shadow-[0_10px_40px_rgba(0,0,0,0.10)] z-20 text-center" data-id="element-99">
            <p className="m-0 text-base tracking-[2px]" data-id="element-100">⭐⭐⭐⭐⭐</p>
            <p className="mt-1 mb-0 text-[11px] text-[#9a8880] font-sans font-semibold" data-id="element-101">
              4.9 / 5 · 847 reviews
            </p>
          </div>
        </div>
      </div>
    </section>;
}